import { useQuery } from '@tanstack/react-query';
import { statesService } from '../statesService';

export const useGetStates = () => {
  return useQuery<any[]>(
    ['get_states'],
    async () => {
      const { data } = await statesService.getStates();
      return [...data];
    },
    {
      initialData: [],
    }
  );
};
